module.exports = __webpack_public_path__ + "img/icon_4_30.b453bbda.png";